var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "editAddressBox" }, [
    _c("div", { staticClass: "editArea itemStyle" }, [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "rightForm" },
        [
          _c("el-cascader", {
            attrs: { size: "large", options: _vm.options },
            on: { change: _vm.addressChange },
            model: {
              value: _vm.$store.state.areaCode,
              callback: function($$v) {
                _vm.$set(_vm.$store.state, "areaCode", $$v)
              },
              expression: "$store.state.areaCode"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "itemStyle" }, [
      _vm._m(1),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "rightForm" },
        [
          _c("el-input", {
            attrs: {
              type: "textarea",
              rows: 2,
              placeholder: "请输入地址",
              resize: "none"
            },
            model: {
              value: _vm.newAddress.address,
              callback: function($$v) {
                _vm.$set(_vm.newAddress, "address", $$v)
              },
              expression: "newAddress.address"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "itemStyle" }, [
      _vm._m(2),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "rightForm" },
        [
          _c("el-input", {
            attrs: { placeholder: "请输入内容" },
            model: {
              value: _vm.newAddress.receiveName,
              callback: function($$v) {
                _vm.$set(_vm.newAddress, "receiveName", $$v)
              },
              expression: "newAddress.receiveName"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "itemStyle" }, [
      _vm._m(3),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "rightForm" },
        [
          _c("el-input", {
            attrs: { placeholder: "请输入内容" },
            model: {
              value: _vm.newAddress.receivePhone,
              callback: function($$v) {
                _vm.$set(_vm.newAddress, "receivePhone", $$v)
              },
              expression: "newAddress.receivePhone"
            }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "itemStyle" }, [
      _c("span"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "rightForm" },
        [
          _c(
            "el-checkbox",
            {
              model: {
                value: _vm.newAddress.defult,
                callback: function($$v) {
                  _vm.$set(_vm.newAddress, "defult", $$v)
                },
                expression: "newAddress.defult"
              }
            },
            [_vm._v("设置为默认收货地址")]
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "dialogFooter" },
      [
        _c(
          "el-button",
          { attrs: { type: "primary" }, on: { click: _vm.newAddressData } },
          [_vm._v("确 定")]
        ),
        _vm._v(" "),
        _c("el-button", { on: { click: _vm.cancelAdd } }, [_vm._v("取 消")])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", [_vm._v("*")]), _vm._v("所在地区：")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", [_vm._v("*")]), _vm._v("详细地址：")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", [_vm._v("*")]), _vm._v("收货人姓名：")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [_c("i", [_vm._v("*")]), _vm._v("手机号码：")])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-c032b014", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-c032b014","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/orderInfo/addAddress.vue
// module id = null
// module chunks = 